<template>
  <div class="dashboard">
    <div class="row row-equal">
      <div class="flex md12">
        <va-card>
          <div class="row row-inside">
            <div class="flex md5">
              <div class="row row-inside">
                <va-button-toggle
                  color="info"
                  outline
                  class="toggle-activite"
                  v-model="showSyndicat"
                  :options="optionsSyndicat"
                />
                <va-popover
                  message="Email à destination de tous les adhérents"
                  placement="left"
                >
                  <va-button
                    class="ma-0 py-3"
                    flat
                    color="info"
                    @click="openCourrielForAll()"
                  >
                    <va-icon size="15px" name="fa fa-envelope" />
                  </va-button>
                </va-popover>
              </div>
            </div>
            <div class="flex md5 vertical-center">
              Contact: {{ contact.titre }} {{ contact.nom }}
              {{ contact.prenom }}
              <va-popover message="Modifier le contact" placement="left">
                <va-button
                  class="ma-0"
                  small
                  flat
                  color="info"
                  @click="updateContact"
                >
                  <va-icon size="15px" name="fa fa-pencil" /> </va-button
              ></va-popover>
              <va-popover
                message="Email à destination du contact"
                placement="left"
              >
                <va-button
                  class="ma-0"
                  small
                  flat
                  color="info"
                  @click="openCourriel(contact.email)"
                  :disabled="!contact.email"
                >
                  <va-icon size="15px" name="fa fa-envelope" />
                </va-button>
              </va-popover>
            </div>
            <div class="flex md1 offset--md1">
              <va-popover
                message="Créer un appel à cotisation"
                placement="left"
              >
                <va-button
                  color="info"
                  class="create-button"
                  @click="openCreate = true"
                >
                  <va-icon size="25px" name="fa fa-plus" />
                </va-button>
              </va-popover>
            </div>
          </div>
          <div class="row align--center margin--top align-content--center">
            <div class="flex md2">
              <va-input
                :value="nomRe"
                placeholder="Nom, Siret"
                removable
                @input="searchNom"
              >
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
            </div>

            <div
              class="
                flex
                md3
                mx-4
                align--center
                margin--top
                align-content--center
              "
            >
              <va-button-toggle
                outline
                color="info"
                class="toggle-activite"
                v-model="showinactive"
                :options="options"
              />
            </div>
            <div class="flex md2 offset--md3">
              <div
                class="
                  row row-inside
                  align--center
                  margin--top
                  align-content--center
                "
              >
                <h5
                  class="selection-nb-title"
                  :style="{ color: this.$themes['info'] }"
                >
                  Sélectionnés : {{ filteredData.length }}
                </h5>
                <va-popover message="Rafraichir" placement="top">
                  <va-button
                    class="selection-refresh"
                    flat
                    large
                    color="info"
                    icon="fa fa-refresh"
                    @click="getListAdherents()"
                  />
                </va-popover>
              </div>
            </div>
            <div class="flex md1">
              <va-input
                class="centered"
                :value="perPage"
                :label="$t('tables.perPage')"
                @input="changePageNumber"
              ></va-input>
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md12">
              <va-data-table
                class="va-table--hoverable va-table--stripped"
                :fields="fields"
                :data="filteredData"
                :no-data-label="$t('poissonnierTable.empty')"
                :per-page="parseInt(perPage)"
                @row-clicked="showEntreprise"
                clickable
              >
                <template slot="actions" slot-scope="props">
                  <div class="row row-inside ma-2">
                    <div class="flex md12">
                      <va-button
                        class="fullwidth"
                        outline
                        :color="
                          props.rowData.date_fin_renouvellement
                            ? 'danger'
                            : 'info'
                        "
                        @click="changeRenouvellement(props.rowData)"
                        >{{
                          props.rowData.date_fin_renouvellement
                            ? moment(
                                props.rowData.date_fin_renouvellement,
                                "YYYY-MM-DD"
                              ).format("DD-MM-YYYY")
                            : "Renouvellement automatique"
                        }}</va-button
                      >
                    </div>
                  </div>
                </template>
              </va-data-table>
            </div>
          </div>
        </va-card>
      </div>
    </div>
    <ContactModal
      :showEditor="showContactEditor"
      :idsyndicat="showSyndicat"
      @close="showContactEditor = false"
      @updateContact="getContact"
    />

    <va-modal
      large
      :title="nomEntrepriseActive + ' - Renouvellement automatique'"
      class="modal"
      v-model="showRenouvellement"
      okText="Sauvegarder"
      cancelText="Annuler"
      v-on:ok="saveChanges"
      v-on:cancel="cancelChange"
    >
      <div class="flex md12">
        <va-date-picker
          :disabled="reactivate"
          :config="{ dateFormat: 'd-m-Y' }"
          label="Date de fin de renouvellement"
          v-model="dateFinRenouvellement"
        />
      </div>
      <div class="flex md12">
        <va-checkbox
          label="Re-activer le renouvellement automatique"
          v-model="reactivate"
        />
      </div>
    </va-modal>
    <dashboard-fiche-entreprise
      v-model="showFicheEntreprise"
      :tableentreprise="SelectedEntreprise"
    />
    <autres-adhesions-manager
      v-model="openCreate"
      :adhesiontype="idOrganisation"
      v-on:ok="getListAdherents"
    />
  </div>
</template>

<script>
import moment from "moment";

import { cloneDeep, debounce, findIndex, deburr } from "lodash";
import DashboardFicheEntreprise from "../dashboard/DashboardFicheEntreprise.vue";

import axios from "axios";
import ContactModal from "./ContactModal";
import AutresAdhesionsManager from "../dashboard/components/AutresAdhesionsManager";

export default {
  name: "dashboard",
  // props: ["nomadh"],
  components: {
    ContactModal,
    DashboardFicheEntreprise,
    AutresAdhesionsManager,
  },

  data() {
    return {
      openCreate: false,
      moment: moment,
      listEntreprises: [],
      showEntList: false,
      idAdtModification: null,
      showAdtModification: false,
      showContactEditor: false,
      showAdtCreation: false,
      optionsSyndicat: [
        { label: "OPAM-B", value: "opam" },
        { label: "AGROMER", value: "agromer" },
        { label: "SCAPP", value: "scapp" },
        { label: "Languedoc-Roussillon", value: "Languedoc-Roussillon" },
        { label: "Vendée", value: "Vendee" },
        { label: "S.D.E.P.", value: "SDEP" },
      ],
      showSyndicat: "opam",
      contact: {
        titre: "test",
        nom: "test",
        prenom: "test",
      },
      listAdhesions: [],
      isaction: false,
      listeAdherents: [],
      nomRe: null,
      options: [
        { label: "Adhérents", value: "active" },
        { label: "Tous", value: "all" },
        { label: "Anciens", value: "inactive" },
      ],
      showinactive: "active",
      perPage: "10",
      showRenouvellement: false,
      nomEntrepriseActive: null,
      identrepriseActive: null,
      dateFinRenouvellement: null,
      reactivate: false,
      showFicheEntreprise: false,
      SelectedEntreprise: null,
      isaction: false,
    };
  },
  computed: {
    filteredData() {
      let filteredData = this.listeAdherents;

      filteredData = filteredData.filter((item) => {
        let boolcond = true;

        if (
          this.showinactive === "active" &&
          moment(item.latest_adhesion, "YYYY-MM-DD")
            .add(1, "year")
            .isBefore(moment())
        ) {
          boolcond = false;
        }

        if (
          this.showinactive === "inactive" &&
          moment(item.latest_adhesion, "YYYY-MM-DD")
            .add(1, "year")
            .isAfter(moment())
        ) {
          boolcond = false;
        }

        if (this.nomRe && this.nomRe.length >= 1) {
          let nomCpre = deburr(this.nomRe).toLowerCase();
          boolcond =
            boolcond &&
            (deburr(item.nom).toLowerCase().includes(nomCpre) ||
              (item.siret && item.siret.includes(nomCpre)));
        }

        return boolcond;
      });

      return filteredData;
    },
    idOrganisation() {
      if (this.showSyndicat === "opam") {
        return 2;
      } else if (this.showSyndicat === "agromer") {
        return 3;
      } else if (this.showSyndicat === "scapp") {
        return 1;
      } else if (this.showSyndicat === "Languedoc-Roussillon") {
        return 6;
      } else if (this.showSyndicat === "Vendee") {
        return 4;
      } else if (this.showSyndicat === "SDEP") {
        return 7;
      } else {
        console.log("no organisation selected");
        return null;
      }
    },
    fields() {
      return [
        {
          name: "nom",
          title: "Entreprise",
          sortField: "nom",
          width: "20%",
        },

        {
          name: "siret",
          title: "Siret",
          sortField: "siret",

          width: "10%",
        },
        {
          name: "debut_adhesion_f",
          title: "Début d'adhésion",
          sortField: "debut_adhesion",

          width: "20%",
        },
        {
          name: "latest_adhesion_f",
          title: "Dernier renouvellement",
          sortField: "latest_adhesion",

          width: "20%",
        },

        {
          name: "__slot:actions",
          title: "Fin du renouvellement automatique",
          sortField: "date_fin_renouvellement_s",
          width: "30%",
        },
      ];
    },
  },
  methods: {
    showEntreprise(entreprise) {
      if (!this.isaction) {
        this.showFicheEntreprise = true;
        this.SelectedEntreprise = entreprise;
      }
      this.isaction = false;
    },
    async saveChanges() {
      this.showRenouvellement = true;

      try {
        let params = {
          idorganisation: this.idOrganisation,
          identreprise: this.identrepriseActive,
          renew: this.reactivate,
          date_fin_renouvellement: this.reactivate
            ? null
            : moment(this.dateFinRenouvellement, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
              ),
        };

        let res = await axios.put("/api/adt/change-renouvellement", params);

        this.getListAdherents();
        this.identrepriseActive = null;
        this.nomEntrepriseActive = null;
        this.dateFinRenouvellement = null;
        this.reactivate = false;
        this.showRenouvellement = false;
      } catch (error) {
        console.log(error);
        this.showToast("Erreur lors de la requete", {
          position: "bottom-center",
          duration: 5000,
        });
      }
    },
    cancelChange() {
      this.showRenouvellement = true;
      this.identrepriseActive = null;
      this.nomEntrepriseActive = null;
      this.dateFinRenouvellement = null;
      this.reactivate = false;
      this.showRenouvellement = false;
    },
    changeRenouvellement(data) {
      this.isaction = true;
      this.identrepriseActive = data.identreprise;
      this.nomEntrepriseActive = data.nom;
      if (data.date_fin_renouvellement) {
        this.dateFinRenouvellement = moment(
          data.date_fin_renouvellement,
          "YYYY-MM-DD"
        ).format("DD-MM-YYYY");
      } else {
        this.dateFinRenouvellement = moment(data.latest_adhesion, "YYYY-MM-DD")
          .add(1, "year")
          .format("DD-MM-YYYY");
      }
      this.reactivate = false;
      this.showRenouvellement = true;
    },
    changePageNumber: debounce(function (perPage) {
      var n = Math.floor(Number(perPage));
      if (n !== Infinity && String(n) === perPage && n >= 0) {
        this.perPage = perPage;
      } else {
        this.perPage = "10";
      }
    }, 400),
    searchNom: debounce(function (nomRe) {
      this.nomRe = nomRe;
    }, 400),
    async getListAdherents() {
      try {
        let results = await axios.get("/api/adt/adherents-organisation", {
          params: { idorganisation: this.idOrganisation },
        });

        for (let ijk = 0; ijk < results.data.length; ijk++) {
          results.data[ijk].debut_adhesion_f = moment(
            results.data[ijk].debut_adhesion,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");
          results.data[ijk].latest_adhesion_f = moment(
            results.data[ijk].latest_adhesion,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");

          results.data[ijk].date_fin_renouvellement_s = results.data[ijk]
            .date_fin_renouvellement_s
            ? results.data[ijk].date_fin_renouvellement_s
            : " ";
        }
        this.listeAdherents = results.data;
      } catch (error) {
        console.log(error);
        this.showToast("Erreur lors du chargement de la liste des adhérents", {
          position: "bottom-center",
          duration: 5000,
        });
      }
    },
    async openCourrielForAll() {
      try {
        let results = await axios.get("/api/adt/emails-organisation", {
          params: { idorganisation: this.idOrganisation },
        });
        this.openCourriel(null, results.data);
      } catch (error) {
        console.log(error);
        this.showToast("Erreur lors de l'ouverture de l'email", {
          position: "bottom-center",
          duration: 5000,
        });
      }
    },
    openCourriel(toemails, bccemails) {
      if (!toemails && !bccemails) {
        this.showToast("Emails non définis", {
          position: "bottom-center",
          duration: 5000,
        });
        return;
      }
      let mailto = "mailto:";
      if (toemails) {
        mailto = mailto + toemails;
      }

      if (bccemails) {
        mailto = mailto + "?bcc=" + bccemails;
      }

      window.open(mailto);
    },

    openNewTab(url) {
      try {
        window.open(url, "_blank");
        this.ok();
      } catch (err) {}
    },

    async getContact() {
      try {
        if (!this.idOrganisation) {
          console.log("no organisation selected");
          return;
        }
        let results = await axios.get("/api/adt/contact", {
          params: { idorg: this.idOrganisation },
        });
        if (results.data) {
          this.contact = results.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    createAdhesion() {},
    updateContact() {
      this.showContactEditor = true;
    },
  },

  mounted() {
    this.getContact();
    this.getListAdherents();
  },
  watch: {
    showFicheEntreprise(value) {
      if (!value) {
        this.getListAdherents();
      }
    },
    showSyndicat() {
      this.getContact();
      this.getListAdherents();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-drop {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0;
  }
}

.fullwidth {
  width: 95%;
}
.vertical-center {
  position: relative;
  top: 0em;
}
.align--center {
  position: relative;
  top: -0.3em;
}
</style>
